import type {
  PhotowallArrivalDirection,
  PhotowallArrivalStyle,
} from "../usePhotowallArrivals";

export type ImageOrderMode = "mixed" | "timeline";
export type RotationMode = "dynamic" | "single-cover" | "single-contain";
export type TransitionSpeed = "slower" | "best" | "faster";
export type QrPosition =
  | "left-top"
  | "right-top"
  | "left-bottom"
  | "right-bottom";

// Reading order, so the corner picker grid and arrow keys line up.
export const QR_POSITIONS = [
  "left-top",
  "right-top",
  "left-bottom",
  "right-bottom",
] as const satisfies readonly QrPosition[];

export const IMAGE_ORDER_MODES = [
  "mixed",
  "timeline",
] as const satisfies readonly ImageOrderMode[];

export const ROTATION_MODES = [
  "dynamic",
  "single-cover",
  "single-contain",
] as const satisfies readonly RotationMode[];

export const TRANSITION_SPEEDS = [
  "slower",
  "best",
  "faster",
] as const satisfies readonly TransitionSpeed[];

export const ARRIVAL_STYLES = [
  "polaroid",
  "bubble",
  "off",
] as const satisfies readonly PhotowallArrivalStyle[];

export const ARRIVAL_DIRECTIONS = [
  "bottom-to-top",
  "top-to-bottom",
  "left-to-right",
  "right-to-left",
] as const satisfies readonly PhotowallArrivalDirection[];

export function isQrPosition(
  value: string | null | undefined
): value is QrPosition {
  return QR_POSITIONS.some((position) => position === value);
}

export interface PhotowallSetupSettings {
  showQR: boolean;
  qrPosition: QrPosition;
  imageOrder: ImageOrderMode;
  rotationMode: RotationMode;
  speed: TransitionSpeed;
  arrivalStyle: PhotowallArrivalStyle;
  arrivalDirection: PhotowallArrivalDirection;
}

export interface PhotowallSetupViewProps {
  eventName: string;
  coverImageUrl: string;
  photoUrls: string[];
  photoCount: number;
  uploadUrl: string;
  settings: PhotowallSetupSettings;
  onSettingsChange: (patch: Partial<PhotowallSetupSettings>) => void;
  onStart: () => void;
}
